import confirmTemplate from '../templates/confirm.hbs';
import modalTemplate from '../templates/modal.hbs';
import modalBackdropTemplate from '../templates/modalBackdrop.hbs';
import $ from 'jquery';

const templateMap = {
    confirm: confirmTemplate,
};

$.fn.sdaModal = function(options) {
    const that = this;
    const data = that.data();
    let to;

    if (!data) {
        return false;
    }

    $(data.target).addClass(data.toggle);

    const opts = $.extend(true, {}, $.fn.sdaModal.defaults, options);

    for (const item in opts) {
        if (opts[item]) {
            data[item] = opts[item];
        }
    }

    const type = data.toggle.replace('sda-', '');

    data.content = $(data.target).html();

    if (type && !opts.template) {
        opts.template = templateMap[type];
    } else if (!opts.template) {
        opts.template = modalTemplate;
    }

    opts.backdrop = opts.backdrop || modalBackdropTemplate();
    opts.backdropTemplate = opts.backdropTemplate || modalBackdropTemplate;

    if (!$(data.target).length) {
        data.content = data.message ? '<i>' + data.message + '</i>' : '<i>Are You Sure?</i>';
        data.target = $('<div id="" class="sda-modal-container ' + data.toggle + '"></div>').insertAfter(
            '.sda-app-body',
        );
    }

    if (!that.hasClass(data.toggle + 'trigger')) {
        $(data.target)
            .html($(opts.template(data)))
            .sdaInitWidgets();
        $(data.target)
            .find('.sda-modal-body')
            .html(data.content);
        that.addClass(data.toggle + 'trigger');
    }

    const modal = {
        toggle() {
            if (that.hasClass('modal-open')) {
                modal.hide();
            } else {
                modal.show();
            }
            opts.onToggle.call(this);
        },

        show() {
            //click functions to open modal
            that.addClass('modal-open');
            to = clearTimeout(to);
            //check if the backdrop/modal is already on the DOM
            if (!$(opts.backdrop).length) {
                $(data.target).before($(opts.backdropTemplate()));

                //set delay to let the backdrop draw before adding the modal
                to = setTimeout(function() {
                    $(opts.backdrop).addClass('modal-open');
                    to = setTimeout(function() {
                        $(data.target).addClass('modal-open');
                        modal.shown();
                    }, opts.delay);
                }, opts.delay);
            }
            opts.onShow.call(this, data);
        },

        hide() {
            //click functions to close modal
            that.removeClass('modal-open');

            $(data.target).removeClass('modal-open');
            to = clearTimeout(to);

            //set delay to let the backdrop draw before adding the modal
            to = setTimeout(function() {
                $(opts.backdrop).removeClass('modal-open');
                to = setTimeout(function() {
                    $(opts.backdrop).remove();
                    modal.hidden();
                }, opts.delay + 100);
            }, opts.delay);
            opts.onHide.call(this);
        },

        shown() {
            opts.onShown.call(this, data);
        },

        hidden() {
            //fired when model closed
            opts.onHidden.call(this);
        },

        destroy() {
            //fired method to completely remove modal form the DOM
            $(data.target).remove();
            opts.onDestroy.call(this);
        },

        cancel() {
            modal.hide();
            opts.onCancel.call(this);
        },

        save() {
            opts.onSave.call(this, modal);
            modal.hide();
        },
    };

    //CLICK EVENTS:
    if (!opts.setupOnly) {
        that.click(function(e) {
            e.preventDefault();
            modal.targetEvent = e;
            modal.show();

            return false;
        });
    }

    $(data.target).on('click', function() {
        if (
            !$(data.target)
                .find('.sda-modal-dialog')
                .is(':hover')
        ) {
            modal.hide();
        }
    });

    $(data.target)
        .find('.modal-close')
        .click(modal.hide);
    $(data.target)
        .find('.sda-modal-cancel')
        .click(modal.cancel);
    $(data.target)
        .find('.sda-modal-save')
        .click(modal.save);

    // Clean up events and DOM elements
    that.on('remove', function() {
        $(opts.backdrop).remove();
        $(data.target).remove();
    });

    return modal;
};

$.fn.sdaModal.defaults = {
    debug: false,
    template: null,
    delay: 100,
    backdrop: '.sda-modal-backdrop',
    targetEvent: null,
    onToggle() {},
    onShow() {},
    onShown() {},
    onHide() {},
    onHidden() {},
    onDestroy() {},
    onCancel() {},
    onSave() {},
};
